import React, { FunctionComponent, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { InputOnChange, InputOnFocus, InputPhone } from '@afterpaytouch/core'
import { PhoneFieldSchema } from '../../types'
import { useVisible, useError } from '../../utils/hooks'
import { usePhoneValidation } from './helper'

export const PhoneField: FunctionComponent<PhoneFieldSchema> = ({
  name = '',
  props,
  options,
  show = true,
  invalid = '',
  validateOnLoad = false,
  testNameSpace = '',
}) => {
  const { register, setValue, trigger, resetField } = useFormContext()
  const { isVisible, values } = useVisible({ name, show })
  const { isError, errorText } = useError({ name, error: props?.error, errorText: props?.errorText })
  const [validity, setValidity] = useState<boolean>()
  const phoneValidation = usePhoneValidation({ validity, invalidMsg: invalid })
  const defaultValue = values ?? props?.value ?? ''
  const component = register(name, {
    ...options,
    validate: {
      ...phoneValidation,
    },
    value: defaultValue,
  })

  const onInputValueBlur = (e: InputOnFocus, rawValue: string, validity: boolean): void => {
    component.onBlur(e)
    if (typeof e.target.value === 'undefined') {
      setValue(name, undefined, { shouldValidate: true })
    }
    setValidity(validity)
    setValue(name, rawValue, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    })
  }

  const onChangeHandler = (e: InputOnChange, countryRawValue: string, validity: boolean): void => {
    setValidity(validity)
    setValue(name, countryRawValue, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: false,
    })
  }

  useEffect(() => {
    if (validateOnLoad) {
      trigger(name)
    }
  }, [])

  useEffect(() => {
    resetField(name, { defaultValue })
  }, [props?.key])

  return isVisible ? (
    <InputPhone {...props} onBlur={onInputValueBlur} onChange={onChangeHandler} testNameSpace={testNameSpace} error={isError} errorText={errorText} />
  ) : null
}
